/* @flow */

import * as React from 'react';

import type {CouponFragment} from 'nutshell-graphql-types';

import {Body} from '../../typography';
import {Stack} from '../../layout';

import {CouponPill} from './coupon-pill';

import './billing-summary.css';

type Props = {
    description: string,
    detail?: ?string,
    coupons?: CouponFragment[],
    customRow?: ?React.Node,
    leftBorder?: boolean,
};

export function DescriptionCell(props: Props) {
    return (
        <td>
            <Stack spacing={4}>
                <div styleName={props.leftBorder ? 'left-border' : ''}>
                    <Body as='div' size='large'>
                        {props.description}
                    </Body>
                    {props.detail && (
                        <Body as='div' color='light' size='small'>
                            {props.detail}
                        </Body>
                    )}
                    {props.coupons &&
                        props.coupons.map((coupon) => {
                            return <CouponPill key={coupon.code} coupon={coupon} />;
                        })}
                    {props.customRow}
                </div>
            </Stack>
        </td>
    );
}
